import { Col, Row } from '@opendoor/atoms/box';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';
import { IconMail, IconPhone } from '@tabler/icons-react';

import { type listingPartnerFor } from './listingDetails';

export const ListingPartnerDetails = ({
  partner,
  headingAs = 'h3',
}: {
  partner: ReturnType<typeof listingPartnerFor>;
  headingAs?: 'h2' | 'h3';
}) => (
  <Col className="min-w-0 gap-2">
    <Text as={headingAs} className="text-body-sm text-od-content-secondary">
      Listing partner
    </Text>
    <Text className="font-medium text-body-md text-od-content-primary">
      {partner.partnerName ?? 'Opendoor'}
    </Text>
    <Row className="items-start gap-2">
      <IconMail aria-hidden="true" className="size-4 shrink-0 text-od-content-secondary" />
      <Link
        href={`mailto:${partner.partnerEmail}`}
        analyticsName="cosmos-make-offer-partner-email"
        className="min-w-0 break-all text-body-sm text-od-content-primary"
      >
        {partner.partnerEmail}
      </Link>
    </Row>
    {partner.partnerPhone ? (
      <Row className="items-start gap-2">
        <IconPhone aria-hidden="true" className="size-4 shrink-0 text-od-content-secondary" />
        <Link
          href={`tel:${partner.partnerPhone}`}
          analyticsName="cosmos-make-offer-partner-phone"
          className="text-body-sm text-od-content-primary"
        >
          {partner.partnerPhone}
        </Link>
      </Row>
    ) : null}
  </Col>
);
